export const styles = {
  header: {
    pb: 0,
  },
};
